<template>
  <a
    v-if="link"
    class="c-contact-link"
    :href="link"
    target="_blank"
    :aria-label="ariaLabelLink">
    <component
      v-if="iconName.length"
      class="c-contact-link__svg"
      :is="iconName"/>
    <slot
      v-else
      name="iconSlot"></slot>
    <span class="c-contact-link__text">{{ text }}</span>
  </a>
</template>

<script>
import CloudIcon from './assets/CloudIcon.vue'
import PadlockIcon from './assets/PadlockIcon.vue'

export default {
  name: 'fh-contact-link',

  components: {
    'Cloud': CloudIcon,
    'Padlock': PadlockIcon
  },

  props: {
    link: {
      type: String,
      default: '',
      required: true
    },
    ariaLabelLink: {
      type: String,
      default: '',
      required: true
    },
    iconName: {
      type: String,
      default: '',
      validator: (value) => {
        return ['', 'Cloud', 'Padlock'].indexOf(value) !== -1
      }
    },
    text: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style lang="scss">
.c-contact-link {
  color: #fff;
  display: inline-block;
  text-decoration: none;
  transition: opacity 0.25s ease-in-out;

  &:focus {
    outline: 2px dashed #fff;
  }
  &:hover {
    opacity: 0.85;

    .c-contact-link__svg {
      opacity: 0.85;
    }
  }
}

.c-contact-link__svg {
  height: 30px;
  width: 30px;
  vertical-align: middle;
  margin-right: .5em;
}

.c-contact-link__text {
  color: #fff;
  vertical-align: middle;
  font-size: 1.2em;
  text-decoration: underline;
}
</style>
